import { ScopeBar } from '@components';
import { useScopeOptions, useUrlAssetScope } from '@hooks';

export default function AssetScopeBar() {
  const options = useScopeOptions();
  const {
    siteId,
    assetId,
    setScope,
    clearScope,
  } = useUrlAssetScope();

  const visibleAssets = options.assets.filter(
    asset => !siteId || asset.siteId === siteId
  );

  const siteLabels = new Map(
    options.sites.map(site => [site.id, site.label])
  );

  const assetOptions = visibleAssets.map(asset => ({
    ...asset,
    label: siteId
      ? asset.label
      : `${asset.label} . ${siteLabels.get(asset.siteId) ?? asset.siteId
      }`,
  }));

  const assetKey = assetId
    ? JSON.stringify([siteId ?? '', assetId])
    : '';

  const invalidSite = siteId && !options.sites.some(
    site => site.id === siteId
  );

  const invalidAsset = assetId && !visibleAssets.some(
    asset => asset.key === assetKey
  );

  const scopeError = !options.isLoading && (
    invalidSite || invalidAsset
  )
    ? 'The selected location is unavailable. Return to fleet to choose another.'
    : null;

  function handleSiteChange(nextSiteId) {
    setScope({
      siteId: nextSiteId || null,
      assetId: null,
    });
  }

  function handleAssetChange(nextAssetKey) {
    if (!nextAssetKey) {
      setScope({ assetId: null });
      return;
    }

    const asset = visibleAssets.find(
      item => item.key === nextAssetKey
    );

    if (!asset) return;

    setScope({
      siteId: asset.siteId,
      assetId: asset.id,
    });
  }

  if (!options.companyId) return null;

  return (
    <ScopeBar
      sites={options.sites}
      assets={assetOptions}
      siteId={siteId ?? ''}
      assetKey={assetKey}
      isLoading={options.isLoading}
      error={options.error || scopeError}
      onSiteChange={handleSiteChange}
      onAssetChange={handleAssetChange}
      onClear={clearScope}
      onRetry={options.reload}
    />
  );
}